import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { css } from 'styled-components/macro';

export const themeCss = css`
    --icon-button-width: 40px;
    --icon-color: var(--theme-color);
    --icon-size: 20px;
    --icon-scale: 1;
`;

export const iconCss = css<any>`
    & {
        ${themeCss}
    }
    & {
        --icon-scale: ${(ie: any) => get(ie, 'scale', null)};
        --icon-stroke-width: ${(ie: any) => get(ie, 'strokeWidth', null)};
        --icon-x: ${(ie: any) => get(ie, 'x', null)};
        --icon-y: ${(ie: any) => get(ie, 'y', null)};
    }
    svg {
        height: 100%;
        position: relative;
        object-fit: contain;
        object-position: center;
        stroke-width: var(--icon-stroke-width);
        width: calc(var(--icon-size) * var(--icon-scale));
        top: calc(var(--icon-y, 0) * 1px);
        left: calc(var(--icon-x, 0) * 1px);
        &.fill {
            fill: var(--icon-color, currentColor);
        }
        &.stroke {
            stroke: ${(props: any) =>
                isEmpty(props.themeColor) ? 'var(--icon-color, currentColor)' : props.themeColor};
        }
    }
`;
